export default "__VITE_ASSET__0f540e28__"